import { ContextMembership } from "./index";
import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface GetMembersResponse extends ResponseData {
    type: '@stemcstudio/organization:get-members-response';
    value?: ContextMembership;
}

/**
 * @hidden
 */
export function isGetMembersResponse(message: MessageEvent): message is MessageEvent<GetMembersResponse> {
    const duck = message as MessageEvent<GetMembersResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/organization:get-members-response') {
        return true;
    } else {
        return false;
    }
}
